<template>
  <div>
    Todo
    <hr>
    <b-form-group :class="{'error-input' : $v.data_todo.title.$error}">
      <label> Todo Title </label>
      <j-input
        v-model="$v.data_todo.title.$model"
        :max-length="255"
        placeholder="Todo Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeTodo">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveTodo">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_todo: {
      title: {
        required,
      },
    },
  },
  data() {
    return {
      data_todo: {
        title: '',
      },
    };
  },
  computed: {
    generateDataTodo() {
      const infoName = this.data_todo.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_todo.title,
        widget_master_id: this.dataMaster.id,

        type: 1,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataTodoUpdate() {
      const infoName = this.data_todo.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_todo.title,
        widget_master_id: this.dataMaster.id,

        type: 1,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_todo.title = JSON.parse(this.dataEdit.info).name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),

    saveTodo() {
      this.$v.data_todo.$touch();
      if (!this.$v.data_todo.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataTodo;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataTodoUpdate;
          this.updateWidget({ widgetId, dataParam });
        }
        this.closeTodo();
      }
    },

    closeTodo() {
      this.$emit('close-field');
      this.data_todo.title = null;
      setTimeout(() => {
        this.$v.data_todo.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jTodoSetup.vue